import { AmazonCheckoutConfig } from './types'; // Adjust import as needed
import ordersMasterService from '../orders/ordersMasterService';

const PROVIDER = 'AMAZON_PAY';


type CallToMethodParams = {
  cartId: string;
  isDraft: boolean;
  methodName: string;
  paramsObject: {
    provider: string;
  };
};

interface OrdersMasterService {
  callToMethod: (params: CallToMethodParams) => Promise<AmazonCheckoutConfig>;
  methodsMap: {
    authorizeSession: string;
  };
}

const typedOrdersMasterService = ordersMasterService as OrdersMasterService;


export const getAmazonPayButtonSettings = async (
  cartId: string,
  isDraft: boolean
): Promise<AmazonCheckoutConfig> => typedOrdersMasterService.callToMethod({
    cartId,
    isDraft,
    methodName: typedOrdersMasterService.methodsMap.authorizeSession,
    paramsObject: { provider: PROVIDER },
  });